import styled from 'styled-components';

const BoxWrapper = styled.div`
  padding: 8px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
`;

export default BoxWrapper;
